import {ChangeDetectorRef, Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {SubscribedComponent} from "../../subscribed.component";
import {NbComponentOrCustomStatus, NbComponentSize, NbComponentShape, NbFormControlState} from "@nebular/theme";

@Component({
    selector: 'bst-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PasswordComponent),
            multi: true
        }
    ],
    standalone: false
})
export class PasswordComponent extends SubscribedComponent implements
  ControlValueAccessor, NbFormControlState, OnDestroy {

  control = new FormControl(null, []);

  @Input() placeholder: string;
  @Input() focused: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() size: NbComponentSize = 'medium';
  @Input() shape: NbComponentShape = 'rectangle';
  @Input() status: NbComponentOrCustomStatus = 'basic';
  @Input() style = null;

  range: {min: number, max: number} = {min: 6, max: 32};

  inRange: boolean = false;
  hasCharacter: boolean = false;
  hasNumber: boolean = false;
  hasSpecial: boolean = false;

  // Function to call when the value changes.
  onChange = (value: string) => {};
  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => {};
  public disabled: boolean = false;

  constructor(public detector: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.subs.push(this.control.valueChanges.subscribe(v => {
      if(this.validatePassword(v)){
        this.onChange(v);
      }
      else{
        this.onChange(null);
      }
    }));
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: string): void {
    this.onChange(null);
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  event($event: any) {
    console.log($event);
  }

  validatePassword(p: string) {
    this.inRange = true;
    this.hasCharacter = true;
    this.hasSpecial = true;
    this.hasNumber = true;

    if (p.length < this.range.min || p.length > this.range.max) {
      this.inRange = false;
    }
    if (p.search(/[a-z]/i) < 0) {
      this.hasCharacter = false;
    }
    if (p.search(/[0-9]/) < 0) {
      this.hasNumber = false;
    }
    if (p.search(/[!@#$%^&*]/) < 0) {
      this.hasSpecial = false;
    }
    return this.inRange && this.hasCharacter && this.hasNumber && this.hasSpecial;
  }

}
